import { t } from '../../i18n';
import { useMember } from '../../session';

/** Home: a welcome until B5 brings the pinned announcement and the next events. */
export function Home() {
  const member = useMember();
  return (
    <section className="screen">
      <h1>{t('home.welcome', { name: member.displayName })}</h1>
      <p className="muted">{t('home.tagline')}</p>
    </section>
  );
}
